import {Link} from "react-router-dom";


function ActionButton({children, href, external = false, css = null, state = null}: any) {
    if (href.includes('limit')) {
        const [path, query] = href.split('?');
        const params = new URLSearchParams(query)
        params.delete('limit');
        href = path + '?' + params.toString();
    }

    return (
        <button className={`flex justify-center items-center py-2.5 px-4 font-body font-bold text-sm ${css ? css : 'border-2 border-grey-100 text-grey-100 w-full xl:w-auto xl:ms-auto'}`}>
            <Link to={href} target={external ? '_blank' : '_self'} className="flex items-center gap-2" state={state}>
                {children}
            </Link>
        </button>
    );
}

export default ActionButton;